import React, { useEffect, useState } from "react";
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";
import Loader from "../common/Loader";

const DualFuel = () => {
    const [season, setSeason] = useState('NA');
    const [dualFuel, setDualFuel] = useState("NA");

    useEffect(() => {
        getDualFuel();
    }, []);

    const getDualFuel = async () => {
        let config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('idToken')
            },
        };

        try {
            const resp = await api.get('/settings/status', config);
            setSeason(resp.data.season);
            setDualFuel(resp.data.dual_fuel);
        } catch(err) {
            toast.error('API error getting season and dual fuel status');
        }
    };

    const toggleSeason = async () => {
        const mySeason = season === 'winter' ? "summer" : season === 'summer' ? "winter" : "";

        if (mySeason !== "") {

            try {
                const resp = await api.post('/settings/season', {"season": mySeason});
                if (resp.status === 200) {
                    setSeason(mySeason);
                }
            } catch(err) {
                toast.error('API error setting season status');
            }
        }
    };

    const toggleDualFuel = async () => {
        if (dualFuel !== "NA") {

            try {
                const resp = await api.post('/settings/dual-fuel', {"dual_fuel": !dualFuel});
                if (resp.status === 200) {
                    setDualFuel(!dualFuel);
                }
            } catch(err) {
                toast.error('API error setting dual fuel status');
            }
        }
    };

    const renderDualFuel = () => {

        if (dualFuel === 'NA') {
            return (
                <div id="dual_fuel_div">
                    <Loader size={20} />
                </div>
            );
        } else if (!dualFuel) {
            return(
                <div id="dual_fuel_div" className="settings-toggle-row">
                    <span className="settings-toggle-row__value">OFF</span>
                    <button className="settings-toggle" type="button" onClick={toggleDualFuel} aria-label="Enable dual fuel" aria-pressed="false">
                        <span />
                    </button>
                </div>
            );
        } else {
            return (
                <div id="dual_fuel_div" className="settings-toggle-row">
                    <span className="settings-toggle-row__value">ON</span>
                    <button className="settings-toggle settings-toggle--on" type="button" onClick={toggleDualFuel} aria-label="Disable dual fuel" aria-pressed="true">
                        <span />
                    </button>
                </div>
            );
        }
    };

    const renderSeason = () => {
        if (season === 'NA') {
            return (
                <div id="season_div">
                    <Loader size={20} />
                </div>
            );
        } else if (season === 'winter') {
            return (
                <div id="season_div" className="settings-toggle-row">
                    <span className="settings-toggle-row__value">WINTER</span>
                    <button className="settings-toggle settings-toggle--season" type="button" onClick={toggleSeason} aria-label="Switch to summer mode" aria-pressed="false">
                        <span />
                    </button>
                </div>
            );
        } else {
            return (
                <div id="season_div" className="settings-toggle-row">
                    <span className="settings-toggle-row__value">SUMMER</span>
                    <button className="settings-toggle settings-toggle--on" type="button" onClick={toggleSeason} aria-label="Switch to winter mode" aria-pressed="true">
                        <span />
                    </button>
                </div>
            );
        }
    };

    return (
        <div id="place_for_dualfuel" className="dual-fuel-settings">
            { renderDualFuel() }
            { renderSeason() }
        </div>
    );
};

export default DualFuel;
